<div class="container contentHeight mainBox">
    <div class="row lonelyStuff mx-auto d-flex justify-content-center actions">
        <!-- Action 1 Add Material-->
        <div *ngIf="Utils.isCTC(role) && Utils.isIxellColorPro(scale)" class="box action">
            <div routerLink="/userClientForm" class="cardAction backgroundWhiteRound">
                <div class="text-dark text-center textAction">
                    <i aria-hidden="true" class="fal fa-power-off fa-3x"></i>
                    <p [translate]="'actionmateriel.newmateriel'"></p>
                </div>
            </div>
        </div>
        <!-- Action 2 Install-->
        <!-- <div class="col-lg-4 col-md-6 mt-3 box">
          <div class="cardAction overlay backgroundWhiteRound">
            <div class="text-dark text-center textAction">
              <i  aria-hidden="true" class="fal fa-calendar-alt  fa-3x textIcon"></i>
              <p [translate]="'actionmateriel.install'"></p>
            </div>
          </div>
        </div>-->
        <!-- Action 3 Order-->
        <div class="box action" *ngIf="(Utils.isIxellColorConnect(scale) || Utils.isIxellColorPro(scale))">
            <div *ngIf="Utils.isUserIxell(role) || Utils.isCTC(role)" routerLink="/catalogue" class="cardAction backgroundWhiteRound">
                <div class="text-dark text-center textAction">
                    <i aria-hidden="true" class="fal fa-shopping-cart fa-3x"></i>
                    <p [translate]="'actionmateriel.order'"></p>
                </div>
            </div>
            <div *ngIf="!Utils.isUserIxell(role) && !Utils.isCTC(role)" class="cardAction overlay backgroundWhiteRound">
                <div class="textIcon text-center textAction">
                    <i aria-hidden="true" class="fal fa-shopping-cart fa-3x"></i>
                    <p [translate]="'actionmateriel.order'"></p>Questions fréquentes
                </div>
            </div>
        </div>

        <!-- Action 4 Contact-->
        <div *ngIf="Utils.isCTC(role) || Utils.isUserIxell(role) " class="box action">
            <div class="cardAction backgroundWhiteRound" routerLink="/assistance">
                <div class="text-dark text-center textAction ">
                    <i aria-hidden="true" class="fal fa-comments-alt fa-3x  textIcon"></i>
                    <p [translate]="'actionmateriel.support'"></p>
                </div>
            </div>
        </div>

        <!-- Action 5 FAQ-->
        <div *ngIf="Utils.isCTC(role) || Utils.isUserIxell(role) || Utils.isUserColor(role)" class="box action ">
            <a (click)="faq()" class="tuto">
                <div class="cardAction backgroundWhiteRound">
                    <div class="text-dark text-center textAction">
                        <i aria-hidden="true" class="fal fa-question fa-3x textIcon"></i>
                        <p [translate]="'actionmateriel.faq'"></p>
                    </div>
                </div>
            </a>
        </div>

        <!-- Action 6 MAJ-->
        <div *ngIf="Utils.isCTC(role)" class="box action">
            <div class="cardAction backgroundWhiteRound" routerLink="/maj">
                <div class=" text-center textAction">
                    <i aria-hidden="true" class="fal fa-arrow-circle-down fa-3x"></i>
                    <p [translate]="'actionmateriel.maj'"></p>
                </div>
            </div>
        </div>

        <!-- Action 7 Rent-->
        <div *ngIf="Utils.isCTC(role) && Utils.isIxellColorPro(scale)" class="box action">
            <div routerLink="/renting" class="cardAction backgroundWhiteRound">
                <div class="text-dark text-center textAction">
                    <i aria-hidden="true" class="fal fa-hand-holding-box fa-3x"></i>
                    <p [translate]="'renting.locationTerminaux'">  </p>
                </div>
            </div>
        </div>

    </div>
</div>
